import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {merge, ReplaySubject} from 'rxjs';
import {filter, first, takeUntil} from 'rxjs/operators';
import {Ofwca} from '../../../shared/interface/ofwca';
import {IddTraining} from '../../../shared/interface/idd-training';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AddIddTrainingCertificateDialogComponent} from '../add-idd-training-certificate-dialog/add-idd-training-certificate-dialog.component';
import {Router} from '@angular/router';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {Dictionary} from '../../../shared/interface/dictionary';
import {
  MEETING_LEADER_INSURANCE_COMPANY
} from '../../../shared/services/dict.service';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IddTrainingCertificate} from '../../../shared/interface/idd-training-certificate';
import {CertificateOverviewDialogComponent} from '../certificate-overview-dialog/certificate-overview-dialog.component';
import {
  IC_GENERALI,
  IC_GENERALI_LIFE,
  IC_WARTA,
  IC_WARTA_LIFE
} from "../../../shared/services/insurance-company.service";

@Component({
  selector: 'app-add-idd-training-certificate',
  templateUrl: './add-idd-training-certificate.component.html',
  styleUrls: ['./add-idd-training-certificate.component.scss']
})
export class AddIddTrainingCertificateComponent implements OnInit, OnDestroy {
  @Input() iddTrainingObject?: IddTraining;
  @Input() dialogRef?: MatDialogRef<AddIddTrainingCertificateDialogComponent>;

  certificateFormValid = false;
  certificateForm: FormGroup;
  ofwcaControl: FormControl;
  iddTrainingControl: FormControl;
  fileControl: FormControl;
  fileNameControl: FormControl;
  fileContentControl: FormControl;
  meetingLeaderControl: FormControl;
  amlControl: FormControl;
  insuranceCompanyControl: FormControl;
  realisedAssetsMinutesControl: FormControl;
  realisedLifeMinutesControl: FormControl;
  realisedGeneralMinutesControl: FormControl;
  realisedAtControl: FormControl;
  realisedAssetsHoursPartControl: FormControl;
  realisedAssetsMinutesPartControl: FormControl;
  realisedLifeHoursPartControl: FormControl;
  realisedLifeMinutesPartControl: FormControl;
  realisedGeneralHoursPartControl: FormControl;
  realisedGeneralMinutesPartControl: FormControl;
  processingRequest = false;
  iddTrainingsSubject: ReplaySubject<ListResponse<IddTraining>> = new ReplaySubject<ListResponse<IddTraining>>(1);
  iddTrainings: IddTraining[] = [];
  selectedInsuranceCompany?: InsuranceCompany;
  selectedIddTraining?: IddTraining;
  selectedOfwca?: Ofwca;
  formErrors = {};
  currentYear = '';

  readonly IC_WARTA = IC_WARTA;
  readonly IC_GENERALI = IC_GENERALI;
  readonly IC_GENERALI_LIFE = IC_GENERALI_LIFE;
  readonly IC_WARTA_LIFE = IC_WARTA_LIFE;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private iddTrainingService: IddTrainingService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.certificateForm = fb.group({
      ofwca: this.ofwcaControl = fb.control(''),
      iddTraining: this.iddTrainingControl = fb.control('', [Validators.required]),
      file: this.fileControl = fb.control(''),
      fileName: this.fileNameControl = fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      meetingLeader: this.meetingLeaderControl = fb.control('', [Validators.required]),
      aml: this.amlControl = fb.control(''),
      insuranceCompany: this.insuranceCompanyControl = fb.control(''),
      realisedAssetsMinutes: this.realisedAssetsMinutesControl = fb.control(0),
      realisedLifeMinutes: this.realisedLifeMinutesControl = fb.control(0),
      realisedGeneralMinutes: this.realisedGeneralMinutesControl = fb.control(0),
      realisedAt: this.realisedAtControl = fb.control('', [Validators.required]),
    });

    this.insuranceCompanyControl.disable();
    this.realisedAssetsHoursPartControl = fb.control(0);
    this.realisedAssetsMinutesPartControl = fb.control(0);
    this.realisedLifeHoursPartControl = fb.control(0);
    this.realisedLifeMinutesPartControl = fb.control(0);
    this.realisedGeneralMinutesPartControl = fb.control(0);
    this.realisedGeneralHoursPartControl = fb.control(0);

    const currentDate = new Date();
    // if (currentDate.getMonth() < 2 ) {
    //   this.currentYear = (currentDate.getFullYear() - 1).toString();
    // }else {
      this.currentYear = (currentDate.getFullYear() ).toString();
    // }
  }

  ngOnInit(): void {
    this.certificateForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.certificateFormValid = this.certificateForm.valid;
      });

    this.iddTrainingsSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: ListResponse<IddTraining>) => {
        this.iddTrainings = response.items;

        let newestIddTraining: IddTraining = null;
        this.iddTrainings.forEach((iddTraining: IddTraining) => {
          if (null === newestIddTraining) {
            newestIddTraining = iddTraining;
            return;
          }

          // if (newestIddTraining.year < iddTraining.year) {
          //   newestIddTraining = iddTraining;
          // }

          if (this.currentYear === iddTraining.year) {
            newestIddTraining = iddTraining;
          }
        });

        this.iddTrainingControl.setValue(newestIddTraining?.uuid);
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((files?: File[]) => files?.length > 0)
      )
      .subscribe((files: File[]) => {
        this.fileNameControl.setValue(files[0].name);
        this.fileContentControl.reset('');

        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          this.fileContentControl.setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
        };
      });

    merge(
      this.realisedAssetsMinutesPartControl.valueChanges,
      this.realisedAssetsHoursPartControl.valueChanges,
      this.realisedLifeMinutesPartControl.valueChanges,
      this.realisedGeneralMinutesPartControl.valueChanges,
      this.realisedLifeHoursPartControl.valueChanges,
      this.realisedGeneralHoursPartControl.valueChanges
    )
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.updateRealisedMinutes());

    this.iddTrainingControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((iddTrainingId: string) => {
        if (!iddTrainingId) {
          return;
        }

        this.iddTrainingService.get(iddTrainingId)
          .subscribe((iddTraining: IddTraining) => this.selectedIddTraining = iddTraining);
      });

    if (this.iddTrainingObject) {
      this.iddTrainingControl.setValue(this.iddTrainingObject.uuid);
    }
  }

  updateRealisedMinutes(): void {
    this.realisedAssetsMinutesControl.setValue(
      (this.realisedAssetsHoursPartControl.value * 60) + this.realisedAssetsMinutesPartControl.value
    );

    this.realisedLifeMinutesControl.setValue(
      (this.realisedLifeHoursPartControl.value * 60) + this.realisedLifeMinutesPartControl.value
    );

    this.realisedGeneralMinutesControl.setValue(
      (this.realisedGeneralHoursPartControl.value * 60) + this.realisedGeneralMinutesPartControl.value
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ofwcaChanged(ofwca: Ofwca): void {
    this.iddTrainingService.loadNotCountedList(
      0, 1000, {ofwca: ofwca.uuid}, this.iddTrainingsSubject
    );
    this.selectedOfwca = ofwca;
    this.selectedIddTraining = null;
  }

  save(): void {
    if (this.realisedAssetsMinutesControl.value < 1 && this.realisedLifeMinutesControl.value < 1 &&
      this.realisedGeneralMinutesControl.value < 1) {
      this.snack.open('Wskaż liczbę godzin szkolenia', '', {duration: 2000});
      return;
    }

    if (this.processingRequest) {
      return;
    }
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.certificateForm, this.formErrors);
    this.formErrors = {};

    this.iddTrainingService.addCertificate(this.iddTrainingControl.value, this.certificateForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Pomyślnie utworzono zaświadczenie', '', {
          duration: 2000,
        });

        if (this.dialogRef) {
          this.dialogRef.close();
        } else {
          const formValue = this.certificateForm.value;
          this.certificateForm.reset({
            ofwca: '',
            iddTraining: '',
            file: '',
            fileName: '',
            fileContent: '',
            meetingLeader: formValue.meetingLeader,
            aml: false,
            insuranceCompany: '',
            realisedAssetsMinutes: 0,
            realisedLifeMinutes: 0,
            realisedAt: '',
          });


          this.realisedAssetsHoursPartControl.setValue(0);
          this.realisedAssetsMinutesPartControl.setValue(0);
          this.realisedLifeHoursPartControl.setValue(0);
          this.realisedLifeMinutesPartControl.setValue(0);
          this.realisedGeneralHoursPartControl.setValue(0);
          this.realisedGeneralMinutesPartControl.setValue(0);
          this.selectedInsuranceCompany = null;
          this.selectedIddTraining = null;
          this.selectedOfwca = null;
          this.processingRequest = false;
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas tworzenia zaświadczenia wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.certificateForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (!this.dialogRef) {
      this.router.navigate(['/szkolenia-idd']);
    } else {
      this.dialogRef.close();
    }
  }

  meetingLeaderChanged(meetingLeader: Dictionary): void {
    if (meetingLeader.key === MEETING_LEADER_INSURANCE_COMPANY) {
      this.insuranceCompanyControl.enable();
    } else {
      this.insuranceCompanyControl.disable();
      this.selectedInsuranceCompany = null;
    }
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }

  onCertImgError($event: any): void {
    $event.target.parentElement.parentElement.style.display = 'none';
  }

  certificateOverview(certificate: IddTrainingCertificate): void {
    this.dialog.open(CertificateOverviewDialogComponent, {
      width: '60vw',
      height: '90vh',
      autoFocus: false,
      data: {
        certificateId: certificate.uuid,
      },
    });
  }

  floor(num: number): number {
    return Math.floor(num);
  }
}
